"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryShowInstructions = void 0;
const graphql_tag_1 = require("graphql-tag");
const fragments_1 = require("./fragments");
/**
 * Retrieve `Show` with `showInstructions` by `$showId`.
 * @param $showId (Required) the `id` of the `Show` to be retrieved
 * @param $sinceInstructionId (Optional) retrieve instructions for `$showId`
 * which occurred after `$sinceInstructionId`, if not provided retrieves all
 * show instructions.
 */
exports.QueryShowInstructions = (0, graphql_tag_1.gql) `
  query ShowInstructions($showId: UUID!, $sinceInstructionId: UUID) {
    showById(showId: $showId) {
      ...ShowWithInstructions
    }
  }
  ${fragments_1.FragmentShowWithInstructions}
`;
